import {defineStore} from 'pinia'
import {components} from '@/types/simmerring.d'
import {Ref} from 'vue'
import {useSimmerringSelectorService} from '~/composables/simmerring_selector_service'
import {SIMMERRING_STORE_CONSTANTS} from '~/assets/js/constants'

export const useSimmerringSelectorStore = defineStore('SimmerringSelectorModule', () => {

  const {SIMM_MEASURE_INCH, SIMM_MEASURE_METRIC, SIMM_TEMP_CELSIUS} = SIMMERRING_STORE_CONSTANTS
  const simmerringSelectorService = useSimmerringSelectorService()

  const shaftDiameter = ref(null)
  const caseDiameter = ref(null)
  const rotationalSpeed = ref(null)
  const temperature = ref(null)
  const pressure = ref(null)
  const tempDefinition = ref(null)
  const lubricant = ref(null)
  const dirtContamination = ref(null)
  const width = ref(null)
  const metaData: any = ref(null)
  const unitLength = ref(SIMM_MEASURE_METRIC as string)
  const expanded = ref(false)

  const unitTemperature = ref(SIMM_TEMP_CELSIUS as string)
  const postAssistantRequestResult = ref<components['schemas']['ApiSimmerringDTO'][]>([])

  const postFinderRequestResult = ref<components['schemas']['ApiSimmerringDTO'][]>([])
  const finderMaterial: any = ref(null)

  const finderDirtContamination: any = ref(null)
  const finderDesign: any = ref(null)
  const finderCurrentStep: Ref<number> = ref(1)
  const assistantCurrentStep: Ref<number> = ref(1)
  const finderCompletedSteps = ref([])
  const assistantCompletedSteps = ref([1])

  const isFetchingMetadata = ref(false)
  const isResultLoading = ref(false)

  const isInch = computed<boolean>(() => {
    return unitLength.value === SIMM_MEASURE_INCH
  })

  const isCelsius = computed<boolean>(() => {
    return unitTemperature.value === SIMM_TEMP_CELSIUS
  })

  const setUnitLength = (unit: string) => {
    unitLength.value = unit
  }

  const setUnitTemperature = (unit: string) => {
    unitTemperature.value = unit
  }

  const setResultLoading = (loading: boolean) => {
    isResultLoading.value = loading
  }

  const getMetaData = async () => {
    if (!metaData.value && isFetchingMetadata.value === false) {
      isFetchingMetadata.value = true
      metaData.value = await simmerringSelectorService.getSimmerringMetadata()
      isFetchingMetadata.value = false
    }

    return metaData.value
  }

  const reset = () => {
    shaftDiameter.value = null
    caseDiameter.value = null
    width.value = null
    unitLength.value = SIMM_MEASURE_METRIC
    unitTemperature.value = SIMM_TEMP_CELSIUS
    rotationalSpeed.value = null
    temperature.value = null
    pressure.value = null
    tempDefinition.value = null
    lubricant.value = null
    dirtContamination.value = null
    finderDesign.value = null
    finderMaterial.value = null
    finderDirtContamination.value = null
    finderCurrentStep.value = 1
    assistantCurrentStep.value = 1
    finderCompletedSteps.value = []
    isResultLoading.value = false
    assistantCompletedSteps.value = [1]
  }

  return {
    // State
    shaftDiameter,
    caseDiameter,
    width,
    unitLength,
    unitTemperature,
    rotationalSpeed,
    temperature,
    pressure,
    tempDefinition,
    lubricant,
    dirtContamination,
    isInch,
    isCelsius,
    finderMaterial,
    finderDirtContamination,
    finderDesign,
    finderCurrentStep,
    assistantCurrentStep,
    finderCompletedSteps,
    assistantCompletedSteps,
    postAssistantRequestResult,
    postFinderRequestResult,
    metaData,
    isResultLoading,
    expanded,
    // Setters
    setUnitLength,
    setUnitTemperature,
    setResultLoading,
    // Actions
    reset,
    getMetaData
  }
})
